/**
 *@author xujinjiang
 *@date 2022/3/3 17:27
 */
import { UrlConfig } from '@/config/UrlConfig';
export class AuthorizationUserUrlConfig {
  // 获取授权用户
  public static getAuthorizationUserList = `${UrlConfig.websiteBaseurl}/thirdparty/organization/user`;

  // 获取用户日志
  public static getUserLogList = `${UrlConfig.websiteBaseurl}/thirdparty/user/log`;
}
